const btnManagementService = {
  label: 'filtros',
  Typography: 'Ningún resultado encontrado'
};

export default btnManagementService;
